import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ActivosService } from './activos.service';
import { Activo } from '../../../core/modelos/activo';
import { ConfirmService } from '../../../core/components/confirm/confirm.service';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { TranslateService } from '../../../../../node_modules/@ngx-translate/core';

/**
 * @title Data table with sorting, pagination, and filtering.
 */
@Component({
    selector: 'fuse-activos-datatable',
    templateUrl: './activos.component.html',
    styleUrls: ['./activos.component.scss']
})
export class ActivosComponent implements AfterViewInit {
    displayedColumns = ['codigo', 'nombre', 'ciudad', 'estado', 'tipologia', 'acciones'];
    dataSource: MatTableDataSource<Activo>;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    // Activos del usuario conectado
    activos: any;

    constructor(
        private activosService: ActivosService,
        private confirmService: ConfirmService,
        private notificaciones: NotificacionesService,
        private translate: TranslateService
    ) {

        this.getActivos();

    }

    getActivos() {

        this.activosService.getActivosDatosBasicos().subscribe(
            data => {
                if (data.success) {
                    this.activos = data.items;
                    // Assign the data to the data source for the table to render
                    this.dataSource = new MatTableDataSource(this.activos);

                    this.dataSource.paginator = this.paginator;

                    // Indica de dónde sacar los datos para ordenar
                    this.dataSource.sortingDataAccessor = (item, property) => {
                        switch (property) {
                            case 'estado': return item.estado.nombre.toLocaleLowerCase();
                            case 'tipologia': return item.tipologia.nombre.toLocaleLowerCase();
                            default: return item[property];
                        }
                    };

                    this.dataSource.sort = this.sort;

                    // Traduzco etiqueta si es español
                    if (this.translate.currentLang === 'es') {
                        this.paginator._intl.itemsPerPageLabel = this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.ItemsPorPagina;
                    }

                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.SinActivos);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );

    }

    /**
     * Set the paginator and sort after the view init since this component will
     * be able to query its view for the initialized paginator and sort.
     */
    ngAfterViewInit() {
    }

    applyFilter(filterValue: string) {
        // Ojo, el filtro que viene por defecto no tiene en cuenta estado, tipologia, etc porque son objetos...
        /*
        * filterValue = filterValue.trim(); // Remove whitespace
        * filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        * this.dataSource.filter = filterValue;
        */

        // Añado este filtro que incorpora los campos que le digamos
        this.dataSource.data = this.activos;

        if (filterValue && filterValue.trim() !== '') {
            this.dataSource.data = this.dataSource.data.filter(
                activo => {

                    if (activo.codigo.toLowerCase().includes(filterValue.toLowerCase())) {
                        return activo.codigo.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    else if (activo.nombre.toLowerCase().includes(filterValue.toLowerCase())) {
                        return activo.nombre.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    else if (activo.ciudad.toLowerCase().includes(filterValue.toLowerCase())) {
                        return activo.ciudad.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    else if (activo.estado.nombre.toLowerCase().includes(filterValue.toLowerCase())) {
                        return activo.estado.nombre.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    else if (activo.tipologia.nombre.toLowerCase().includes(filterValue.toLowerCase())) {
                        return activo.tipologia.nombre.toLowerCase().includes(filterValue.toLowerCase());
                    }

                }
            );
        }
    }

    borrarActivo(id: number) {
        this.confirmService.confirm(
            this.notificaciones.mensajes.IdiomaActual.Activos.TituloBorrar,
            this.notificaciones.mensajes.IdiomaActual.Activos.MensajeBorrar).subscribe(
                result => {
                    if (result) {
                        this.activosService.deleteActivo(id).subscribe(
                            data => {
                                if (data.success) {
                                    // this.activosService.removeAssetsFromCache();
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoBorrado);
                                    this.getActivos();
                                } else {
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoNOBorrado);
                                }
                            },
                            err => {
                                this.notificaciones.errorServidor(err.status);
                            }
                        );
                    }
                }
            );
    }

    selectFile(event) {
        let archivoExcel: File;
        const reader = new FileReader();
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            // Límite de 5MB
            if (file.size > 5242880) {
                event = null;
                this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.FotoGrande);
            }
            else if (file.type !== 'application/vnd.ms-excel' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                event = null;
                this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.TipoExcelNoValido);
            } else {
                reader.readAsDataURL(file);
                reader.onload = () => {
                    archivoExcel = (<any>reader.result).split(',')[1];
                    this.uploadListaActivos(archivoExcel);
                };
            }
        }
    }

    uploadListaActivos(excelActivos: File) {

        this.activosService.cargarActivos(excelActivos).subscribe(
            data => {
                if (data.success) {
                    this.getActivos();
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.CargaExcel.ActivosCargados);
                } else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.CargaExcel.ActivosNoCargados);
                }
            },
            () => this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.CargaExcel.ActivosNoCargados)
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/activos/activos.component.ts